import { useQuery } from 'react-query';
import CMSService from 'App/services/CMSService';
import { useMemo } from 'react';

export const useFectchUnpublishedContent = (type) => {
    const { data, isLoading, error } = useQuery(
        ['unpublishedContentList', type],
        () => CMSService.getContentGroups(type, { unpublished: true, hasChanges: true }),
        { enabled: !!type }
    );

    const sortedList = useMemo(() => Object.values(data ?? {}).sort((a, b) => a.name.localeCompare(b.name)), [data]);

    return {
        rawList: sortedList,
        isLoading,
        error,
    };
};

export default useFectchUnpublishedContent;
